'use strict';

class ReportFormPdf {
  constructor(reportService, invoiceService, Notification) {
    this.reportService = reportService;
    this.invoiceService = invoiceService;
    this.Notification = Notification;
  }

  $onInit() {
    this.params = {
      columns: [],
      from: moment().startOf('month').format('DD.MM.YY'),
      to: moment().endOf('month').format('DD.MM.YY'),
      format: 'PDF'
    };
    this.columns = [];
    this.type = 'date';
    this.invoice = {
      from: null,
      to: null
    };

    this.load();
    this.loadColumns();
  }

  load() {
    this.invoiceService.statistics()
      .then((resp) => {
        this.invoice = {
          from: resp.data && resp.data.invoiceNumber ? resp.data.invoiceNumber.first : null,
          to: resp.data && resp.data.invoiceNumber ? resp.data.invoiceNumber.last : null
        };
      });
  }

  selectColumn(key) {
    if ($.inArray(key, this.columns) === -1) {
      this.columns.push(key);
    } else {
      let index = this.columns.indexOf(key);
      this.columns.splice(index, 1);
    }

    angular.extend(this.params, {
      columns: this.columns
    });
  }

  loadColumns() {
    this.reportService.availableColumns('invoices')
      .then((resp) => {
        // preselect
        resp.data.forEach((c) => {
          this.selectColumn(c.key);
        }, this);
      });
  }

  download(format, email = false) {
    let params = {
      format: format
    };

    if (this.type === 'invoiceNumber' && this.invoice.from !== null && this.invoice.to !== null) {
      angular.extend(params, {
        invoiceNumberFrom: this.invoice.from,
        invoiceNumberTo: this.invoice.to
      });
    } else {
      angular.extend(params, {
        columns: this.params.columns.join(','),
        from: moment(this.params.from, 'DD.MM.YY').format('YYYY-MM-DD'),
        to: moment(this.params.to, 'DD.MM.YY').format('YYYY-MM-DD')
      });
    }

    if (email) {
      params.email = this.email;
    }

    this.reportService.download('invoices', params, email)
      .then((resp) => {
        if (resp) {
          this.Notification.success(`Rapporten er sendt til ${this.email}`);
        }
      });
  }
}

ReportFormPdf.$inject = ['reportService', 'invoiceService', 'Notification'];

const reportFormPdf = {
  bindings: {
    email: '<'
  },
  controller: ReportFormPdf,
  template: `
    <h2>Eksporter regninger til PDF-fil</h2>

    <div class="row">
      <div class="large-6 columns">
        <div class="panel" ng-class="{ callout: $ctrl.type === 'date' }" ng-click="$ctrl.type = 'date'">
          <h4>Basert p&aring; dato</h4>
        </div>
      </div>
      <div class="large-6 columns">
        <div class="panel" ng-class="{ callout: $ctrl.type === 'invoiceNumber' }" ng-click="$ctrl.type = 'invoiceNumber'">
          <h4>Basert p&aring; fakturanummer</h4>
        </div>
      </div>
    </div>

    <div ng-show="$ctrl.type === 'date'" report-generator ng-model="$ctrl.params"></div>

    <fieldset ng-show="$ctrl.type === 'invoiceNumber'">
      <h3 class="subheader">Eksporter basert p&aring; fakturanummer</h3>
      <div class="row">
        <div class="large-6 columns">
          <label for="from">Fra og med</label>
          <input type="number" min="0" ng-model="$ctrl.invoice.from">
        </div>
        <div class="large-6 columns">
          <label for="to">Til og med</label>
          <input type="number" min="0" ng-model="$ctrl.invoice.to">
        </div>
      </div>
    </fieldset>

    <fieldset>
      <label for="email">E-postadresse</label>
      <input id="email" name="email" type="email" ng-model="$ctrl.email">
    </fieldset>

    <a href ng-click="$ctrl.download('PDF')" class="button secondary"><i class="fa fa-file-o"></i> Last ned</a>

    <a ng-show="$ctrl.email" href ng-click="$ctrl.download('PDF', true)" class="button secondary"><i class="fa fa-envelope-o"></i> Send på e-post</a>
  `
};

angular
  .module('SendRegning')
  .component('reportFormPdf', reportFormPdf)
  .config(($routeProvider) => {
    $routeProvider
      .when('/rapport/pdf', {
        title: 'Eksporter til PDF',
        template: '<report-form-pdf email="$resolve.email" />',
        secure: true,
        resolve: {
          email: (originatorService) => originatorService.get().then((resp) => resp.data.contact.email)
        }
      });
  });
